import BaseLayout from "@/pages/BaseLayout";

import isWalletUser from "@/middleware/isWalletUser";
import hasPermissionTo from "@/middleware/hasPermission";

export default {
    path: '/service-accounts',
    name: 'service.accounts',
    component: BaseLayout,
    meta: {
        middleware: [
            isWalletUser,
            hasPermissionTo('READ', 'SERVICE_ACCOUNTS')
        ]
    },
    redirect: { name: 'service.accounts.list' },
    children: [
        {
            path: "",
            name: 'service.accounts.list',
            component: () => import('@/modules/service-account/views/service-account-list.vue'),
        },
        {
            path: "new",
            name: 'service.accounts.create',
            component: () => import('@/modules/service-account/views/service-account-create.vue'),
        },
        {
            path: "show",
            name: 'service.accounts.show',
            component: () => import('@/modules/service-account/views/service-account-show.vue'),
        },
    ]
};
